import React from "react";
import { statusMeta } from "@/lib/status";

export function StatusBadge({ status, className = "" }) {
  const m = statusMeta(status);
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${m.color} ${className}`}
    >
      {m.label}
    </span>
  );
}
